<template>
  <div class="cf-switch-input">
    <input
      :id="name"
      v-model="val"
      class="cf-switch-input__input"
      type="checkbox"
      :disabled="disabled"
      :name="name"
      :value="modelValue"
    >

    <label
      class="cf-switch-input__label"
      :for="name"
    >
      <slot>
        <span
          v-if="label"
          class="cf-switch-input__label-text"
        >
          {{ label }}
        </span>
      </slot>

      <button
        v-if="showInfoIcon"
        class="cf-button"
        type="button"
        tabindex="-1"
        @click="iconClickHandler"
      >
        <span class="cf-icon far fa-info-circle" />
      </button>

      <span class="cf-switch-input__toggle">
        <span class="cf-switch-input__handle" />
      </span>
    </label>
  </div>
</template>


<script>
  export default {
    name: 'CfSwitchInput',

    props: {
      description: {
        type: String,
        default: null
      },

      label: {
        type: String,
        default: null
      },

      name: {
        type: String,
        required: true
      },

      modelValue: {
        type: Boolean,
        default: null
      },

      showInfoIcon: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    },

    methods: {
      iconClickHandler() {
        this.$openModal('notice-modal', { description: this.description });
      }
    }
  };
</script>
